import { createSlice } from '@reduxjs/toolkit';
import { type ExtractValues } from 'src/types/utilities';

import { AdminConfigNavConsts } from './common/constants';

// **** Types **** //

interface AdminConfigState {
  selectedTab: ExtractValues<typeof AdminConfigNavConsts, 'TAB'>;
  selectedTaskTab: ExtractValues<typeof AdminConfigNavConsts['Task'], 'TAB'>;
  selectedFormTab: ExtractValues<typeof AdminConfigNavConsts['Form'], 'TAB'>;
}

// **** Setup **** //

const initialState: AdminConfigState = {
  selectedTab: AdminConfigNavConsts.Site.TAB,
  selectedTaskTab: AdminConfigNavConsts.Task.Tasks.TAB,
  selectedFormTab: AdminConfigNavConsts.Form.Table.TAB,
};

const { reducer, actions } = createSlice({
  name: 'adminConfigPageSlice',
  initialState,
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setSelectedTaskTab: (state, action) => {
      state.selectedTaskTab = action.payload;
    },
    setSelectedFormTab: (state, action) => {
      state.selectedFormTab = action.payload;
    },
  },
});

// **** Export **** //

export const { setSelectedTab, setSelectedTaskTab, setSelectedFormTab } = actions;
export default reducer;
